import { apiClient } from '../api'

export class RepReportDataSource {
  static path = '/rep-report'

    static getPreviewDocTranscriptAndCert(params) {
    return apiClient.post(
      `${this.path}/tsc/report/${params?.type_data}/download?tsc_document_id=${params.tsc_document_id}&tsc_document_detail_id=${params.tsc_document_detail_id}&tsc_t_doc_delivery_id=${params.tsc_t_doc_delivery_id}`,
      {
        type_group: params.type_group,
        draft: params?.draft,
      },
      {
        responseType: 'blob',
      },
    )
  }

  static verifyDocument(docId, detailId, paramsObj) {
    return apiClient.patch(
      `${this.path}/verify-document/${paramsObj?.type_group == 'D' ? paramsObj?.type_data : 'nondigital'}`,
      {
        document_type_status: paramsObj.document_type_status,
        type_group: paramsObj.type_group,
      },
      {
        params: {
          tsc_document_id: docId,
          tsc_document_detail_id: detailId,
          ...(paramsObj?.tsc_t_doc_delivery_id ? { tsc_t_doc_delivery_id: paramsObj?.tsc_t_doc_delivery_id } : null),
        },
      },
    )
  }

  static downloadGrdCondDocTemplate(params) {
    return apiClient.post(
      `${this.path}/grd-report/download-graduate-condition-template?condition_type_code=${params.condition_type_code}&grd_condition_topic_id=${params.grd_condition_topic_id}&condition_level=${params.condition_level}&language=${params.language}&file_name=${params.file_name}`,
      {},
      { responseType: 'blob' },
    )
  }

  static exportGrdCondDoc(params) {
    return apiClient.post(
      `${this.path}/grd-report/export-graduate-condition-data?condition_type_code=${params.condition_type_code}&grd_condition_topic_id=${params.grd_condition_topic_id}&condition_level=${params.condition_level}&language=${params.language}&file_name=${params.file_name}&status_code=${params.status_code}&mode=${params.mode}&grd_condition_import_id=${params.grd_condition_import_id}`,
      {},
      { responseType: 'blob' },
    )
  }

  static exportSummaryReqDoc(params) {
    return apiClient.post(
      `${this.path}/tsc/report/export-summary-request-document`,
      {
        academic_year: params.academic_year,
        semester: params.semester,
        campus_code: params?.campusCode,
        faculty_code: params?.facultyCode,
        department_code: params?.departmentCode,
        major_code: params?.majorCode,
        edulevel_code: params?.edulevel_code,
        document_type_status: params?.document_type_status,
        delivery_code: params?.delivery_code,
        payment_status: params?.payment_status,
        requested_start_dt: params?.requested_start_dt,
        requested_end_dt: params?.requested_end_dt,
        student_data: params?.student_data,
        ...(params?.type_name && ['เลือกทั้งหมด', 'Select All'].includes(params.type_name)
          ? null
          : params?.type_name
          ? { type_name: params?.type_name }
          : null),
      },
      {
        responseType: 'blob',
      },
    )
  }

  static advisorAnnouncement(id) {
    return apiClient.get(`${this.path}/adv/report/export-announcement-advisor?announcement_advisor_id=${id}&language=EN`, {
      responseType: 'blob',
    })
  }

  static graduateAnnounceReport(grd_nominate_id, have_logo = true) {
    return apiClient.post(
      `${this.path}/graduate/graduate-announce-report`,
      {
        grd_nominate_id: grd_nominate_id,
        have_logo: have_logo,
      },
      {
        responseType: 'blob',
      },
    )
  }

  static stdGrdReport(params) {
    return apiClient.post(`${this.path}/graduate/std-graduate-report`, params, { responseType: 'blob' })
  }

    static getTransriptDoc(params) {
    return apiClient.post(`${this.path}/grd-report/tsc-document`, params, {
      responseType: 'blob',
    })
  }

  static exportAddressLabel(payload) {
    return apiClient.post(`${this.path}/tsc/report/address-label`, payload, {
      responseType: 'blob',
    })
  }

  static getReqGrdCopyDoc(params) {
    return apiClient.get(`${this.path}/graduate/all-student-request-graduation`, { params: params, responseType: 'arraybuffer' })
  }

  static downloadOrderGrdList(params) {
    return apiClient.get(`${this.path}/graduate/download-arrange-grd`, { params: params, responseType: 'arraybuffer' })
  }

  static printOrderGrdList(academic_year) {
    return apiClient.get(`${this.path}/graduate/arrange-grd-report?academic_year=${academic_year}`, {
      responseType: 'blob',
    })
  }

  static previewGrdCerDoc(payload) {
    return apiClient.post(`${this.path}/grd-report/student-degree`, payload, {
      responseType: 'blob',
    })
  }

  static exportAllGrdCondition(payload) {
    return apiClient.get(`${this.path}/grd-report/export-condition-all-data`, { params: payload, responseType: 'arraybuffer' })
  }

  static exportSummaryDashboard(payload) {
    return apiClient.post(`${this.path}/grd-report/summary-dashboard`, payload, {
      responseType: 'arraybuffer',
    })
  }

  static exportEditNameReportGrdDetail(payload) {
    return apiClient.get(`${this.path}/graduate/register-degree-adjust-name`, {
      params: payload,
      responseType: 'arraybuffer',
    })
  }

  // ดาวน์โหลด CSV ผ่านลิงก์จากเมล (token เป็น JWT ส่งไปใน body, endpoint ไม่ได้ secure)
  static downloadAssessmentAnonymousAnswerCsv(token) {
    return apiClient.post(
      `${this.path}/assessment/report/assessment-anonymous-answer-csv/download`,
      { token },
      { responseType: 'blob' },
    )
  }
}
